//export const EntryFilter ={
const entryFilter = {
  state: {
    items: {
      entryAt: null,
      circleNames: null,
      hashtagNames: null,
      freeWords: null,  
    }
  },
  getters: {
    items(state) { return state.items },
  },
  mutations: {
    setItems (state, value) {
      state.items = value      
    },
    initItems (state) {
      state.items = {
        entryAt: null,
        circleNames: null,
        hashtagNames: null,
        freeWords: null,
      }
    },
  },
  actions: {},
  modules: {}
}
export default entryFilter